import { get, post, put, patch, del } from '../http/http';
// 登录
export default {
    login: (val, config) => post('/auth/login', val, config), // 登录
    logout: (val) => get('/auth/logout', val), // 登出
    register: (val, config) => post('/auth/reg', val, config), // 注册
    resetPass: (val) => post('/auth/resetPass', val), // 修改密码
    resetPassword: (val, config) => patch('/auth/reset-pass', val, config), // 修改密码
    getIdentifyCode: (val, config) => post('/auth/identify-code', val, config), // 手机登录验证码
    loginSim: (val, config) => post('/auth/login-sim', val, config), // 手机登录
    getRegCode: (val, config) => post('/auth/reg-code', val, config), // 手机注册验证码
    regPass: (val, config) => put('/auth/reg-pass', val, config), // 手机注册完的设置密码
    identify: (val, config) => post('/auth/identify', val, config) // 忘记密码-身份校验
}